// main.js - Vue application entry point
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'

// Import CSS
import './assets/styles/main.css'

// Import plugins
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

// Toast configuration
const toastOptions = {
  position: 'top-right',
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false
}

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(Toast, toastOptions)

// Global properties
app.config.globalProperties.$appName = 'QR Code Generator'
app.config.globalProperties.$version = '1.0.0'

app.mount('#app')